
	
import { show, hide } from '../helpers/transition'

export default ({ 
	menu, 
	openClass = 'slidemenu-is-open',
	noScrollClass = 'slidemenu-no-scroll',
	overlayClass = 'slidemenu-overlay',
	openSelector = 'slidemenu-open', 
	closeSelector = 'slidemenu-close', 
	toggleSelector = 'slidemenu-toggle',
}) => {

	if (typeof menu === 'string') menu = document.querySelector(menu)

	const buttonOpen = [...document.querySelectorAll(openSelector)]
	const buttonClose = [...document.querySelectorAll(closeSelector)]
	const buttonToggle = [...document.querySelectorAll(toggleSelector)]
	
	const overlay = document.createElement('div')
	overlay.classList.add(overlayClass)
	menu.parentNode.insertBefore(overlay, menu)
	
	// track open state
	let isOpen = false
	let previousFocus = null
	menu.setAttribute('aria-hidden', true)

	// allow focusing of menu
	menu.setAttribute('tabindex', '-1')

	// main

	const disableScroll = () => document.documentElement.classList.add(noScrollClass)
	const enableScroll = () => document.documentElement.classList.remove(noScrollClass)

	const open = event => {
		isOpen = true
		previousFocus = document.activeElement
		show(menu, openClass, () => menu.focus())
		show(overlay, openClass)
		disableScroll()
		menu.setAttribute('aria-hidden', false)
	}

	const close = event => {
		isOpen = false
		previousFocus && previousFocus.focus()
		hide(menu, openClass)
		hide(overlay, openClass)
		menu.setAttribute('aria-hidden', true)
		enableScroll()
	}

	const toggle = () => isOpen ? close() : open()

	// bind events
	document.addEventListener('keydown', event => event.which === 27 && isOpen && close())
	buttonOpen.map(button => button.addEventListener('click', open))
	buttonClose.map(button => button.addEventListener('click', close))
	buttonToggle.map(button => button.addEventListener('click', toggle))
	overlay.addEventListener('click', close)

	return {
		open, close, toggle
	}
}